import type { Polygon } from 'geojson';

/**
 * Incident workspace seeded for the Japan demo. Incidents have no demo_key, so
 * this exact name is the idempotency handle.
 */
export const JAPAN_INCIDENT_NAME =
  'Tokyo Bay earthquake and Keihin chemical release';

export const JAPAN_INCIDENT_TYPE = 'Earthquake';

export const JAPAN_DIVISIONS_LAYER_NAME =
  'Tokyo Bay ICS Divisions / 東京湾 ICS 区域';

export const JAPAN_DIVISIONS_LAYER_DESCRIPTION =
  'Operational divisions for the Tokyo Bay earthquake HADR and NEO response.';

export type JapanDivision = {
  id: string;
  name: string;
  nameJa: string;
  description: string;
  polygonColor: string;
  polygonOpacity: number;
  geometry: Polygon;
};

function box(
  minLon: number,
  minLat: number,
  maxLon: number,
  maxLat: number
): Polygon {
  return {
    type: 'Polygon',
    coordinates: [
      [
        [minLon, minLat],
        [maxLon, minLat],
        [maxLon, maxLat],
        [minLon, maxLat],
        [minLon, minLat],
      ],
    ],
  };
}

/** One division per line of effort, so the IAP objectives can name them. */
export const JAPAN_DIVISIONS: JapanDivision[] = [
  {
    id: 'kawasaki',
    name: 'Division A — Kawasaki',
    nameJa: 'A区域 — 川崎',
    description:
      'Keihin chemical complex and the Port of Kawasaki. Source control, plume monitoring and decontamination.',
    polygonColor: '#b91c1c',
    polygonOpacity: 0.22,
    geometry: box(139.69, 35.46, 139.79, 35.53),
  },
  {
    id: 'haneda',
    name: 'Division B — Haneda',
    nameJa: 'B区域 — 羽田',
    description:
      'Haneda Airport under the plume. Runway closures, terminal shelter in place and arrival diversions.',
    polygonColor: '#c2410c',
    polygonOpacity: 0.22,
    geometry: box(139.75, 35.53, 139.81, 35.57),
  },
  {
    id: 'yokohama',
    name: 'Division C — Yokohama',
    nameJa: 'C区域 — 横浜',
    description:
      'Port of Yokohama (Honmoku). Berth assessment and the alternate port for relief shipping.',
    polygonColor: '#a16207',
    polygonOpacity: 0.22,
    geometry: box(139.62, 35.4, 139.7, 35.46),
  },
  {
    id: 'yokosuka',
    name: 'Division D — Yokosuka (HADR)',
    nameJa: 'D区域 — 横須賀（HADR）',
    description:
      'Fleet Activities Yokosuka and US Naval Hospital Yokosuka. HADR staging and medical surge.',
    polygonColor: '#15803d',
    polygonOpacity: 0.22,
    geometry: box(139.62, 35.26, 139.7, 35.31),
  },
  {
    id: 'yokota',
    name: 'Division E — Yokota (NEO)',
    nameJa: 'E区域 — 横田（NEO）',
    description:
      'Yokota Air Base evacuation control centre and NEO airlift, with Narita as the alternate.',
    polygonColor: '#1d4ed8',
    polygonOpacity: 0.22,
    geometry: box(139.32, 35.72, 139.37, 35.77),
  },
];
